import axios from 'axios'
import store from './store'

axios.defaults.baseURL = process.env.VUE_APP_REST_URL
axios.defaults.withCredentials = true
axios.defaults.timeout = 15000

export default class RestDataSource {
  constructor(bus) {
    this.eventBus = bus
  }

  async listObject(object) {
    return (await this.sendRequest('GET', `/${object}`, null, false, false)).data
  }
  async getData(id, page) {
    return (await this.sendRequest('GET', `/dpfo/${page}/${id}`)).data
  }
  async getDataSilent(id, page) {
    return (await this.sendRequest('GET', `/dpfo/${page}/${id}`, null, false, false)).data
  }
  async getItems(id, page) {
    return (await this.sendRequest('GET', `/dpfo/${page}?filter[parent]=${id}`, null, false)).data
  }
  async updateData(item, page) {
    await this.sendRequest('PUT', `/dpfo/${page}/${item.id}`, item)
  }
  async updateItem(item, page) {
    return (await this.sendRequest('PUT', `/dpfo/${page}`, item)).data
  }

  async postPayment(item) {
    return (await this.sendRequest('POST', '/payments', item)).data
  }
  async postPaymentParams(url, params) {
    return (await this.sendRequest('POST', `${url}`, params)).data
  }

  async createData(item, page) {
    return (await this.sendRequest('POST', `/dpfo/${page}`, item)).data
  }
  async copyFo(id) {
    return (await this.sendRequest('POST', `/dpfo/subjects/${id}/copy`)).data
  }
  async crDod(id) {
    return (await this.sendRequest('POST', `/dpfo/subjects/${id}/dodatocne`)).data
  }
  async delDod(id) {
    return (await this.sendRequest('DELETE', `/dpfo/subjects/${id}`)).data
  }
  async deleteData(item, page) {
    await this.sendRequest('DELETE', `/dpfo/${page}/${item.id}`)
  }
  async listFo(page, adress) {
    return (await this.sendRequest('GET', `/dpfo/subjects?fields=id,type,druh,year,priezvisko,titul,meno,dic,rc${adress}&per-page=10&page=${page}&sort=-year,-id`, null, false)).data
  }
  // --------INCOMES---------------
  async getOutlandIncome(tabulka, id, odsek) {
    return (await this.sendRequest('GET', `/dpfo/outland?filter[parent]=${id}&filter[tabulka]=${tabulka}&filter[odsek]=${odsek}`, null, false)).data
  }
  async getOutland78(tabulka, id) {
    return (await this.sendRequest('GET', `/dpfo/outland?filter[parent]=${id}&filter[tabulka]=${tabulka}`, null, false)).data
  }

  async getSposobId(id, par) {
    try {
      return (await this.sendRequest('GET', `/dpfo/subjects/${id}/findRecord/${par}`, null, false, false)).data
    } catch (err) {
      if (err.response.status === 404) {
        store.commit('stopLoader')
        return null
      }
      return err
    }
  }
  // ----------SENDREQUEST------------
  async sendRequest(method, url, data, useEventBus = true, useLoader = true) {
    try {
      if (useLoader) {
        store.commit('startLoader')
        const resource = await axios.request({ method, url, data })
        store.commit('stopLoader')
        store.commit('toastable')
        return resource
      }
      const resource = await axios.request({ method, url, data })
      return resource
    } catch (err) {
      store.commit('noToast')
      if (store.state.domain === 'jedno') {
        this.checkForUnauthorized(err)
        this.checkMembership(err)
      }

      if (useEventBus) {
        if (err.response) {
          this.eventBus.$emit('httpError', err.response)
        } else {
          const message = err.code === 'ECONNABORTED' ? 'HTTP timeout' : 'HTTP error'
          this.eventBus.$emit('httpError', message)
        }
        store.commit('stopLoader')
      }
      throw err
    }
  }

  checkForUnauthorized = (err) => {
    if (err.response.statusText === 'Unauthorized') {
      window.location.href = '/user/login'
    }
  }
  checkMembership = (err) => {
    if (err.response.status === 402) {
      window.location.href = '/membership?limit=reached'
    }
  }
}
